import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import styles from "./VerificationProcess.module.css";
import clockImg from "../../../assets/images/clock.png";
import { TextComponent } from "../../../components";
import { getUser } from "../../../Store/Actions/AuthAction";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
const VerificationProcess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const user = useSelector((state) => state.AuthReducer.user);

  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
  }, [dispatch]);

  useEffect(() => {
    if (user?.is_profile_completed === true && user?.is_approved === true) {
      navigate("/dashboard");
    }
  }, [user, navigate]);


  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <img src={clockImg} className={styles.clockImg} />
          <TextComponent text={"Your profile is under verification process"} className={styles.heading} />
          <TextComponent text={"to make our platform secure we verify every new user it can take upto 48 Hours"} className={styles.text} />
        </div>
      </div>
    </div>
  );
};

export default VerificationProcess;
